import { useAppDispatch, useAppSelector } from 'hooks/redux';
import * as React from 'react';
import { useCallback, useEffect } from 'react';

import { addPlannedSpendingDialog } from 'components/Dialogs/AddPlannedSpending/actions';
// COMPONENTS
import StdDialog from 'components/Dialogs/StdDialog';
import StdDialogActions from 'components/Dialogs/StdDialogActions';
import StdDialogContent from 'components/Dialogs/StdDialogContent';

import { dateSelectors } from 'app-components/flux/date';
import { freeToSpendSelectors, freeToSpendTypes } from 'app-components/flux/free-to-spend';
import { usePreferenceV2 } from 'app-components/flux/preferences-v2';
import { rootUiActions } from 'app-components/flux/root-ui';
// APP-COMPONENTS
import { tracker } from 'app-components/utils/core';
import PlannedSpending from 'assets/images/spendingPlan/PlannedSpending.svg';
import SimpleContentView from '../SimpleContentView';

const { GSFStageEnum } = freeToSpendTypes;

function Planned({
  initialId,
  callback,
}: {
  initialId?: string;
  callback?: (catName: string) => void;
}) {
  const [_gettingStartedFlowPhase, setGettingStartedFlowPhase] = usePreferenceV2(
    'sSPGettingStartedFlowPhase',
    GSFStageEnum.COMPLETE,
  );
  const dispatch = useAppDispatch();

  const startDate = useAppSelector((state) => dateSelectors.getStartOfMonthDate(state));
  const freeToSpendId = useAppSelector((state) => freeToSpendSelectors.getFreeToSpendForDate(state, startDate)).id;
  const plannedItems = useAppSelector((state) => freeToSpendSelectors.getPlannedSpendingItemsForDate(state, startDate));

  const onClose = useCallback(() => {
    dispatch(rootUiActions.removeDialog());
  }, [dispatch]);

  const closeAndContinue = useCallback(
    (catName: string) => {
      if (callback) {
        callback(catName);
      }
      setGettingStartedFlowPhase(GSFStageEnum.OTHER);
      onClose();
    },
    [callback, onClose, setGettingStartedFlowPhase],
  );

  useEffect(() => {
    tracker.track(tracker.events.viewPlannedSpendIntro);
  }, []); // eslint-disable react-hooks/exhaustive-deps

  const addPlannedItem = () => {
    dispatch(
      addPlannedSpendingDialog({
        freeToSpendId: freeToSpendId ?? '',
        plannedItems,
        startDate,
        initialId,
        callback: closeAndContinue,
      }),
    );
  };

  return (
    <StdDialog
      onClose={onClose}
      open={true}
      sharedcomponentid={'FIRST_TIME_USE_DIALOG_V2'}
      showCloseButton
      size='md'
      title={''}
    >
      <StdDialogContent
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <SimpleContentView
          image={<img width='128px' height='128px' src={PlannedSpending} />}
          mainText={'Add Planned Spend'}
          secondaryText={"Set money aside for specific things you know you'll need, like gas or groceries."}
        />
      </StdDialogContent>
      <StdDialogActions
        primary={{
          id: 'primary-button',
          children: 'Continue',
          onClick: addPlannedItem,
          variant: 'contained',
        }}
      />
    </StdDialog>
  );
}

export default Planned;
